import React from 'react';
import { Button } from '../ui/button';
import { ExternalLink, ShoppingCart } from 'lucide-react';
import { Link } from 'react-router-dom';

// Helper function to safely render text with italic tags
const renderTextWithItalics = (text) => {
  const parts = text.split(/(<em>.*?<\/em>)/g);
  return parts.map((part, index) => {
    if (part.startsWith('<em>') && part.endsWith('</em>')) {
      const content = part.slice(4, -5);
      return <em key={`em-${content.substring(0, 20)}-${index}`}>{content}</em>;
    }
    return <span key={`text-${index}`}>{part}</span>;
  });
};

const BookContent = ({ book }) => {
  const renderParagraph = (paragraph, idx) => {
    // For Nora's Story (book.id 1), bold the first sentence of the first paragraph
    if (book.id === 1 && idx === 0) {
      const firstSentenceEnd = paragraph.indexOf('. ') + 1;
      const firstSentence = paragraph.substring(0, firstSentenceEnd);
      const restOfParagraph = paragraph.substring(firstSentenceEnd);
      return (
        <p key={`${book.id}-${idx}`} className="text-lg text-slate-700 leading-relaxed mb-4">
          <strong>{renderTextWithItalics(firstSentence)}</strong>
          {renderTextWithItalics(restOfParagraph)}
        </p>
      );
    }
    return (
      <p key={`${book.id}-${idx}`} className="text-lg text-slate-700 leading-relaxed mb-4">
        {renderTextWithItalics(paragraph)}
      </p>
    );
  };

  return (
    <div className="space-y-6">
      <div>
        <div className="inline-block bg-amber-100 text-amber-800 px-4 py-2 rounded-full text-sm font-semibold mb-4">
          {book.status}
        </div>
        {book.id !== 1 && (
          <h3 className="text-4xl font-serif font-bold text-slate-900 mb-4">
            {book.title}
          </h3>
        )}
        {book.id !== 1 && (
          <p className="text-xl text-slate-600 mb-6 leading-relaxed">
            {book.description}
          </p>
        )}
        {book.fullDescription.split('\n\n').map((paragraph, idx) => 
          renderParagraph(paragraph, idx)
        )}
      </div>

      <div className="flex flex-wrap gap-4 pt-4">
        {book.purchaseLink && (
          <Button 
            asChild
            className={`${book.buttonColor} text-white font-semibold`}
          >
            <a href={book.purchaseLink} target="_blank" rel="noopener noreferrer">
              <ShoppingCart className="w-4 h-4 mr-2" />
              Purchase Book
            </a>
          </Button>
        )}
        {book.sampleLink && (
          <Button 
            asChild
            variant="outline" 
            className="border-2 border-slate-700 text-slate-700 hover:bg-slate-700 hover:text-white font-semibold"
          >
            <Link to={book.sampleLink}>
              <ExternalLink className="w-4 h-4 mr-2" />
              Read Sample
            </Link>
          </Button>
        )}
      </div>
    </div>
  );
};

export default BookContent;
